export default () => ({
  meActived: false,
  scrollPosition: 0,
  topSearchBar: false
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/resources/data.js